import type { PublicProduct } from '@starkey/shared'
import { Sparkles } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Card } from '@/components/ui/Card'

export function ProductCard({ product }: { product: PublicProduct }) {
  return (
    <div className="product-card-reveal">
      <Link className="product-card-link" to={`/products/${product.slug}`}>
        <Card className="product-card">
          <div
            className="product-card__cover"
            style={
              product.coverImageUrl
                ? { backgroundImage: `linear-gradient(rgba(16, 24, 40, 0.08), rgba(16, 24, 40, 0.08)), url(${product.coverImageUrl})` }
                : { background: product.coverGradient }
            }
          />
          <div className="product-card__body">
            <div className="product-card__head">
              <div>
                <h3>{product.name}</h3>
                <p>{product.summary}</p>
              </div>
              <Sparkles size={18} />
            </div>
            <div className="product-card__tags">
              {product.sellingPoints.map(point => (
                <span key={point}>{point}</span>
              ))}
            </div>
          </div>
        </Card>
      </Link>
    </div>
  )
}
